export default __webpack_public_path__ + "static/media/time_cancel_icon.0f7ee776.svg";